import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";
import scrollama from "scrollama";

export default class extends Controller {
  connect() {
    const items = this.element.querySelectorAll(".slide");

    items.forEach((e) => {
      e.style.opacity = 0;
    });

    this.itemAnimated = {};

    setTimeout(() => {
      this.scroller = scrollama();
      this.scroller
        .setup({
          // debug: true,
          offset: 0.95,
          once: true,
          step: items,
        })
        .onStepEnter(this.animateItem.bind(this));
    }, 500);
  }

  animateItem(e) {
    animate(e.element, {
      opacity: [0, 1],
      translateY: ["5rem", "0"],
      duration: 600,
      delay: e.index % 2 ? 100 : 0,
      ease: "inOutSine",
    });

    // const event = new CustomEvent("reveal");
    // e.element.dispatchEvent(event);
  }
}
